import { render, staticRenderFns } from "./StepsHolder.vue?vue&type=template&id=1d932151&scoped=true&"
import script from "./StepsHolder.vue?vue&type=script&lang=js&"
export * from "./StepsHolder.vue?vue&type=script&lang=js&"
import style0 from "./StepsHolder.vue?vue&type=style&index=0&id=1d932151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d932151",
  null
  
)

export default component.exports